(function (global, factory) {
  typeof exports === 'object' && typeof module !== 'undefined' ? factory(exports, require('final-form')) :
  typeof define === 'function' && define.amd ? define(['exports', 'final-form'], factory) :
  (factory((global.VueFinalForm = {}),global['final-form']));
}(this, (function (exports,finalForm) { 'use strict';

  /*!
   * nano-assign v1.0.0
   * (c) 2017-present egoist <0x142857@gmail.com>
   * Released under the MIT License.
   */

  var index = function(obj) {
    var arguments$1 = arguments;

    for (var i = 1; i < arguments.length; i++) {
      // eslint-disable-next-line guard-for-in, prefer-rest-params
      for (var p in arguments[i]) { obj[p] = arguments$1[i][p]; }
    }
    return obj
  };

  var nanoAssign_common = index;

  var getChildren = function getChildren(children) {
    return Array.isArray(children) ? children : [children];
  };

  var composeValidators = function composeValidators(validators) {
    for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      args[_key - 1] = arguments[_key];
    }

    return validators.reduce(function (error, validator) {
      return error || validator.apply(void 0, args);
    }, undefined);
  };

  var composeFormValidators = function composeFormValidators(validators) {
    return function () {
      for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
        args[_key2] = arguments[_key2];
      }

      return composeValidators.apply(void 0, [validators].concat(args));
    };
  };
  var composeFieldValidators = function composeFieldValidators(validators) {
    return function () {
      return function () {
        for (var _len3 = arguments.length, args = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
          args[_key3] = arguments[_key3];
        }

        return composeValidators.apply(void 0, [validators].concat(args));
      };
    };
  };

  var defaultSubscription = finalForm.formSubscriptionItems.reduce(function (result, key) {
    result[key] = true;
    return result;
  }, {});
  var FinalForm = {
    name: 'final-form',
    props: {
      initialValues: Object,
      submit: {
        type: Function,
        default: function _default() {}
      },
      subscription: Object,
      validate: [Function, Array]
    },
    provide: function provide() {
      return {
        finalForm: this.finalForm
      };
    },
    data: function data() {
      return {
        finalForm: finalForm.createForm({
          onSubmit: this.submit,
          initialValues: this.initialValues,
          validate: Array.isArray(this.validate) ? composeFormValidators(this.validate) : this.validate
        }),
        formState: null
      };
    },
    methods: {
      handleSubmit: function handleSubmit(e) {
        e && e.preventDefault();
        this.finalForm.submit();
      }
    },
    created: function created() {
      var _this = this;

      this.unsubscribe = this.finalForm.subscribe(function (state) {
        _this.formState = state;

        _this.$emit('change', state);
      }, this.subscription || defaultSubscription);
    },
    beforeDestroy: function beforeDestroy() {
      this.unsubscribe();
    },
    render: function render(h) {
      var children = this.$scopedSlots.default ? this.$scopedSlots.default(nanoAssign_common({}, this.formState, {
        handleSubmit: this.handleSubmit,
        mutators: this.finalForm.mutators,
        batch: this.finalForm.batch,
        blur: this.finalForm.blur,
        change: this.finalForm.change,
        focus: this.finalForm.focus,
        initialize: this.finalForm.initialize,
        reset: this.finalForm.reset
      })) : this.$slots.default;
      return h('div', null, getChildren(children));
    }
  };

  function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;

    for (i = 0; i < sourceKeys.length; i++) {
      key = sourceKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      target[key] = source[key];
    }

    return target;
  }

  function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};

    var target = _objectWithoutPropertiesLoose(source, excluded);

    var key, i;

    if (Object.getOwnPropertySymbols) {
      var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

      for (i = 0; i < sourceSymbolKeys.length; i++) {
        key = sourceSymbolKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
        target[key] = source[key];
      }
    }

    return target;
  }

  var FinalField = {
    name: 'final-field',
    inject: ['finalForm'],
    props: {
      name: {
        required: true,
        type: String
      },
      validate: [Function, Array],
      subscription: Object
    },
    data: function data() {
      return {
        fieldState: {}
      };
    },
    created: function created() {
      var _this = this;

      var subscription = this.subscription || finalForm.fieldSubscriptionItems.reduce(function (result, key) {
        result[key] = true;
        return result;
      }, {});
      this.unsubscribe = this.finalForm.registerField(this.name, function (fieldState) {
        _this.fieldState = fieldState;

        _this.$emit('change', fieldState);
      }, subscription, {
        getValidator: Array.isArray(this.validate) ? composeFieldValidators(this.validate) : function () {
          return _this.validate;
        }
      });
    },
    beforeDestroy: function beforeDestroy() {
      this.unsubscribe();
    },
    computed: {
      fieldEvents: function fieldEvents() {
        var _this2 = this;

        return {
          input: function input(e) {
            return _this2.fieldState.change(e.target.value);
          },
          blur: function blur() {
            return _this2.fieldState.blur();
          },
          focus: function focus() {
            return _this2.fieldState.focus();
          }
        };
      }
    },
    render: function render() {
      var _this$fieldState = this.fieldState,
          blur = _this$fieldState.blur,
          change = _this$fieldState.change,
          focus = _this$fieldState.focus,
          value = _this$fieldState.value,
          name = _this$fieldState.name,
          meta = _objectWithoutProperties(_this$fieldState, ["blur", "change", "focus", "value", "name"]);

      var children = this.$scopedSlots.default({
        events: this.fieldEvents,
        change: change,
        value: value,
        name: name,
        meta: meta
      });
      return getChildren(children)[0];
    }
  };

  if (typeof window !== 'undefined' && window.Vue) {
    window.Vue.component(FinalForm.name, FinalForm);
    window.Vue.component(FinalField.name, FinalField);
  }

  exports.FinalForm = FinalForm;
  exports.FinalField = FinalField;

  Object.defineProperty(exports, '__esModule', { value: true });

})));
